import { render } from "./order-confirmation.vue?vue&type=template&id=6c55d67d&scoped=true&ts=true"
import script from "./order-confirmation.vue?vue&type=script&lang=ts"
export * from "./order-confirmation.vue?vue&type=script&lang=ts"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c55d67d"]])

export default __exports__